const user_centralCN = {
    USER_CENTRAL_01:'我的收藏',
    USER_CENTRAL_02:'我的公司',
    USER_CENTRAL_03:'我的联系人',
    USER_CENTRAL_04:'共有',
    USER_CENTRAL_05:'个结果 , 已选择',
    USER_CENTRAL_06:'个联系人',
    USER_CENTRAL_10:'联系信息',
    USER_CENTRAL_13:'岗位',
    USER_CENTRAL_13_U:'岗位',
    USER_CENTRAL_14:'级别',
    USER_CENTRAL_14_U:'级别',
    USER_CENTRAL_15:'邮箱',
    USER_CENTRAL_16:'公司信息',
    USER_CENTRAL_21:'年营业额',
    USER_CENTRAL_24:'总部地址',
    USER_CENTRAL_25:'产品服务',
    USER_CENTRAL_26:'简介',
    USER_CENTRAL_28:'暂无数据',
    USER_CENTRAL_29:'个公司',
}
export default user_centralCN


// WEBPACK FOOTER //
// ./src/lan/cn/cn_user_central.js